// extracted by mini-css-extract-plugin
export default {"form":"styles_form__ZrcUn","img":"styles_img__5kQvm","body":"styles_body__8kgmm","btn":"styles_btn__m2kk4","inputGroup":"styles_inputGroup__3aA8D","input":"styles_input__fZG10"};